var _path, _rect, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 65,
    viewBox: "0 0 138 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.9 0H65.1C60.645 0 57.0405 3.65625 57.0405 8.125L57 56.875C57 61.3438 60.645 65 65.1 65H129.9C134.355 65 138 61.3438 138 56.875V8.125C138 3.65625 134.355 0 129.9 0ZM128.28 17.2656L99.6465 35.2219C98.3505 36.0344 96.6495 36.0344 95.3535 35.2219L66.72 17.2656C65.7075 16.6156 65.1 15.5188 65.1 14.3406C65.1 11.6188 68.0565 9.99375 70.365 11.4156L97.5 28.4375L124.635 11.4156C126.944 9.99375 129.9 11.6188 129.9 14.3406C129.9 15.5188 129.293 16.6156 128.28 17.2656Z",
    fill: "#BFF736"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 12,
    width: 28,
    height: 7,
    rx: 3.5,
    fill: "#BFF736"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 37,
    width: 43,
    height: 7,
    rx: 3.5,
    fill: "#BFF736"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 50,
    width: 60,
    height: 7,
    rx: 3.5,
    fill: "#BFF736"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 25,
    width: 48,
    height: 7,
    rx: 3.5,
    fill: "#BFF736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.81ead7c73e9c616274efed82badeff3d.svg";
export { ForwardRef as ReactComponent };